import Blockly from 'scratch-blocks';

// Quantum Blocks Messages
Blockly.Msg.QUANTUM_MEASURE = 'measure';
Blockly.Msg.QUANTUM_WHENMEASURED = 'when measured';
Blockly.Msg.QUANTUM_WHENSUPERPOSITIONSTART = 'when superposition started';
Blockly.Msg.QUANTUM_WHENENTANGLEMENTSTART = 'when entanglement started';
Blockly.Msg.QUANTUM_SUPERPOSITION = 'superposition variable %1 nº clones %2 lista %3';
Blockly.Msg.QUANTUM_SUPERPOSITION1 = 'superpose %1 possibilities: %2 list: %3';
Blockly.Msg.QUANTUM_SUPERPOSITION_NO_LIST = 'superpose %1 possibilities: %2 ';
Blockly.Msg.QUANTUM_SUPERPOSITION_ONLY_LIST = 'superpose %1 list: %2 ';
Blockly.Msg.QUANTUM_ENTANGLEMENT = 'entangle %1 with %2 possibilities: %3 list: %4';
Blockly.Msg.QUANTUM_ENTANGLEMENT_NO_LIST = 'entangle %1 with %2 possibilities: %3';
Blockly.Msg.QUANTUM_ENTANGLEMENT_ONLY_LIST = 'entangle %1 with %2 list: %3';
Blockly.Msg.QUANTUM_SUPERPOSITION1_POSITION = 'position';
Blockly.Msg.QUANTUM_SUPERPOSITION1_DIRECTION = 'direction';
Blockly.Msg.QUANTUM_SUPERPOSITION1_COLOR = 'colour';
Blockly.Msg.QUANTUM_SUPERPOSITION1_COSTUME = 'costume';
Blockly.Msg.QUANTUM_SUPERPOSITION1_SIZE = 'size';

// Si quieres soportar español, puedes agregar una detección simple o forzarlo aquí:
// if (window._locale === 'es') { ... tus traducciones en español ... }